// QR-code decoding for TOTP setup. Pure-local: an image File is drawn to a
// canvas and decoded with jsQR. No network. Never logs the decoded value.

import jsQR from 'jsqr';

// Run jsQR over raw ImageData. Returns the decoded text, or null if no QR code
// is found. Split out from the File path so the decode logic is testable
// without a real canvas.
export function decodeQrFromImageData(imageData) {
  if (!imageData || !imageData.data) return null;
  const result = jsQR(imageData.data, imageData.width, imageData.height);
  return result && typeof result.data === 'string' && result.data.length > 0
    ? result.data
    : null;
}

// Decode a QR code from an image File. Loads the image, draws it to a canvas,
// reads the pixels, and runs jsQR. Returns the decoded text, or null on any
// failure (unreadable file, no canvas 2d context, no QR detected).
// Browser-only (canvas). No network.
export async function decodeQrFromFile(file) {
  if (!file) return null;

  let bitmap;
  try {
    bitmap = await createImageBitmap(file);
  } catch {
    return null;
  }

  try {
    const canvas = document.createElement('canvas');
    canvas.width = bitmap.width;
    canvas.height = bitmap.height;
    const ctx = canvas.getContext('2d');
    if (!ctx) return null;
    ctx.drawImage(bitmap, 0, 0);
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    return decodeQrFromImageData(imageData);
  } catch {
    return null;
  } finally {
    bitmap.close?.();
  }
}
